import { createApp } from 'vue'
import App from './SocialEducation.vue'

createApp(App).mount('#app-social-education')
